<template>
  <div v-if="related.length > 0">
    <div class="mb-12 text-center">
      <h2 class="mb-4 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
        Related <span class="bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-transparent">Projects</span>
      </h2>
      <p class="text-lg text-gray-600 dark:text-gray-400">
        Explore more projects in this category
      </p>
    </div>

    <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
      <NuxtLink
        v-for="project in related"
        :key="project.slug"
        :to="`/projects/${project.slug}`"
        class="group relative overflow-hidden rounded-2xl bg-card-gradient shadow-soft transition-all duration-500 hover:-translate-y-2 hover:shadow-soft-lg dark:bg-card-gradient-dark"
      >
        <div class="relative overflow-hidden">
          <img
            :src="project.images[0]?.src"
            class="h-48 w-full object-cover transition-transform duration-500 group-hover:scale-110"
            :alt="project.name"
            width="800"
            height="600"
            loading="lazy"
          >
          <!-- Gradient overlay -->
          <div class="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

          <!-- Hover overlay with icon -->
          <div class="absolute inset-0 flex items-center justify-center opacity-0 transition-all duration-300 group-hover:opacity-100">
            <div class="flex size-12 items-center justify-center rounded-full bg-white/90 shadow-lg dark:bg-gray-800/90">
              <PhArrowRight class="size-6 text-accent" />
            </div>
          </div>
        </div>

        <!-- Content -->
        <div class="p-6">
          <div class="mb-3">
            <div class="inline-flex items-center rounded-full bg-accent/10 px-3 py-1 dark:bg-accent/20">
              <span class="text-xs font-medium text-accent dark:text-accent">{{ PROJECT_TYPE_LABELS[project.type] }}</span>
            </div>
          </div>

          <h3 class="mb-2 text-lg font-bold text-ternary-dark transition-colors duration-300 group-hover:text-accent dark:text-ternary-light dark:group-hover:text-accent">
            {{ project.name }}
          </h3>

          <p class="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
            {{ project.subtitle }}
          </p>

          <!-- Bottom border accent -->
          <div class="mt-4 h-1 w-0 rounded-full bg-gradient-to-r from-accent to-gradient-end transition-all duration-500 group-hover:w-full" />
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Project } from '~/utils/projects'
import { PhArrowRight } from '@phosphor-icons/vue'
import { PROJECT_TYPE_LABELS, relatedProjects } from '~/utils/projects'

const props = withDefaults(defineProps<{
  currentProject: Project
  limit?: number
}>(), { limit: 4 })

const related = computed(() => relatedProjects(props.currentProject, props.limit))
</script>
